import { useParams } from 'react-router-dom';
import UserSetup from './UserSetup';
import Content from '@/components/Content';

const UsersEdit = () => {
    const { id } = useParams();
    const userId = Number(id);

    return (
        <Content title='Benutzer Einstellungen'>
            <UserSetup userId={userId} />
        </Content>
    )
};

export default UsersEdit;
